export default __webpack_public_path__ + "18d0c643a74df1ee836dd6005de41f74.png";